import { AccordionProps, Collapse } from '@mui/material';
import React from 'react';
import * as Styled from './accordion.styles';

const Accordion: React.FC<AccordionProps> = ({ TransitionComponent = Collapse, disableGutters = true, ...props }) => {
  return <Styled.Accordion disableGutters={disableGutters} TransitionComponent={TransitionComponent} {...props} />;
};

export default React.memo(Accordion);
